import { useQuery } from 'react-query'

import { useAuthedFetch } from '../auth/useAuthedFetch'
import withFetchCancel from '../libs/withFetchCancel'
import useTranslations from '../i18n/useTranslations'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

export const useGeneralRates = (clientCode, date) => {
  const authedFetch = useAuthedFetch()
  const t = useTranslations()

  const query = useQuery(
    ['generalRates', { clientCode, date }],
    () =>
      withFetchCancel(signal =>
        authedFetch(
          'GET',
          `${BACKEND_ENDPOINT}/client/${clientCode}/general_rates?date=${date}`,
          {
            parseJSON: true,
            signal,
          },
        ),
      ),
    {
      enabled: clientCode && date !== undefined,
      select: ({ data }) => {
        if (!data?.length)
          return [
            {
              label: t('billing:select-bill'),
              value: null,
              client_commited_deliveries: 0,
              disabled: true,
            },
          ]
        let result = data?.map(element => ({
          label: element?.client_business_name,
          value: element?.client_code,
          client_commited_deliveries: element?.client_commited_deliveries,
        }))
        result.push({
          label: t('billing:select-bill'),
          value: null,
          client_commited_deliveries: 0,
          disabled: true,
        })
        return result
      },
    },
  )

  return query
}
